export default __webpack_public_path__ + "static/media/search.77758ae8.svg";